export const dialIntentEnum = {
  1: '服务咨询',
  2: '投诉建议',
  3: '待购主动提醒'
}
export const columns = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    width: 180,
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    dataIndex: 'calleeName',
    key: 'calleeName',
    align: 'left',
    width: 180,
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '拨号诉求',
    dataIndex: 'dialIntentStr',
    key: 'dialIntentStr',
    align: 'left',
    width: 180,
    slots: {
      customRender: 'dialIntentStr'
    }
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    align: 'left',
    width: 200
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'left',
    width: 200
  },
  {
    title: '电话时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'left',
    width: 200,
    slots: {
      customRender: 'duration'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'endStatusDesc',
    key: 'endStatusDesc',
    align: 'left',
    width: 150,
    slots: {
      customRender: 'endStatusDesc'
    }
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    fixed: 'right',
    align: 'left',
    width: 100,
    slots: {
      customRender: 'action'
    }
  }
]
